import { FileSelectorConfig } from '@src/js/common/ark-extensions/dc-components/docs-component-drive-selector/type';
import ArkLoader from '@src/js/common/ark-extensions';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import {
    DRIVE_SELECTOR_MOBILE, DRIVE_SELECTOR_PC,
} from '@src/js/common/ark-extensions/dc-components/docs-component-drive-selector/component-config';
import { IExtension } from '@tencent/ark-extensions';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

const DEFAULT_MAX_NUM = 1;
/**
 * 该类负责打开和关闭drive文件选择器
 */
export default class DriveFileSelector {
    private static instance;

    public static getInstance(): DriveFileSelector {
        if (!DriveFileSelector.instance) {
            DriveFileSelector.instance = new DriveFileSelector();
        }
        return DriveFileSelector.instance;
    }

    private fileSelectorExtension: IExtension;

    /**
     * 打开drive文件选择器面板
     * @param config
     * @param isMobile 是否移动端，默认为false
     */
    public async showFileSelector(config: FileSelectorConfig, isMobile?: boolean): Promise<void> {
        const finalConfig = { ...this.getDefaultConfig(), ...config };
        let fileSelectorExtension;
        try {
            if (isMobile) {
                fileSelectorExtension = await ArkLoader.extensionService.getExtension(DRIVE_SELECTOR_MOBILE.name);
            } else {
                fileSelectorExtension = await ArkLoader.extensionService.getExtension(DRIVE_SELECTOR_PC.name);
            }
        } catch (e) {
            window.log?.error?.('load drive file selector error');
        }
        fileSelectorExtension.insertDoc({
            hostFileId: SlideDataServices.DocInfoManager()?.padId ?? '',
            ...finalConfig,
        });
        this.fileSelectorExtension = fileSelectorExtension;
    }

    /**
     * 关闭已打开的面板
     */
    public hideFileSelector() {
        this.fileSelectorExtension?.hide();
    }

    private getDefaultConfig(): FileSelectorConfig {
        const tabs = ['Recent', 'MyDoc'];
        if (getCacConfigByKey('custom.toolbarFileMenu.showBusinessSpace', false)) {
            tabs.push('BusinessSpace');
        }
        return {
            maxNumber: DEFAULT_MAX_NUM,
            tabs,
        };
    }
}
